import { securedAxiosInstance } from "../axios";

class AnnouncementsService {
  fetchIndex() {
    return securedAxiosInstance.get("/announcements");
  }
}

export default new AnnouncementsService();
